import React from "react";
import PolicyLayout from "../Policy/PolicyLayout";

const TermsandCondition = () => {
  const sections = [
    {
      id: "overview",
      title: "General Terms",
      body: (
        <>
          <p>
            By accessing or using the GlobalGiftPass.io website (the "Website"),
            you agree to be bound by these Terms &amp; Conditions. Please read
            them carefully before using the Website. If you do not agree, you
            must refrain from accessing or using the Website.
          </p>
          <ul>
            <li>
              The price and currency displayed at checkout will be the same as
              that printed on the Transaction Receipt; the amount charged to
              your card will be in your card's currency.
            </li>
            <li>
              Customers under the age of 18 shall not register as a User of the
              Website and shall not transact on or use the Website.
            </li>
            <li>
              Cardholders must retain a copy of transaction records and
              GlobalGiftPass.io's policies and rules.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account.
            </li>
          </ul>
        </>
      ),
    },
    {
      id: "ip",
      title: "Intellectual Property",
      body: (
        <>
          <p>
            The Website, including all trademarks, copyrights, database rights,
            and other intellectual property rights associated with it, is owned
            by <b>VentureWorks Dynamics LLC</b>. You are not permitted to:
          </p>
          <ul>
            <li>Copy, modify, distribute, or reproduce any part of the Website</li>
            <li>Attempt to extract or reverse engineer the source code</li>
            <li>Translate, adapt, or create derivative works based on the Website</li>
          </ul>
          <p>All rights not explicitly granted herein are reserved.</p>
        </>
      ),
    },
    {
      id: "use",
      title: "Use of the Website",
      body:
        "GlobalGiftPass.io is committed to providing an efficient and reliable platform. We reserve the right to modify or update the Website at any time, and to introduce charges for certain services with clear communication. Your use of the Website is contingent upon your adherence to these terms and applicable laws.",
    },
    {
      id: "data-security",
      title: "Personal Data and Security",
      body:
        "To deliver our services, we may collect and process personal data provided by you. By using the Website, you agree to our Privacy Policy. It is your responsibility to secure your device and access to the Website. Avoid jailbreaking or rooting your device, as this may compromise its security and impact functionality. We are not responsible for breaches arising from unauthorized device modifications.",
    },
    {
      id: "internet",
      title: "Internet Connectivity",
      body: (
        <>
          <p>
            The Website requires an active internet connection.{" "}
            <b>GlobalGiftPass.io</b> is not liable for reduced functionality or
            service interruptions due to:
          </p>
          <ul>
            <li>Lack of internet access</li>
            <li>Insufficient mobile data allowances</li>
            <li>Roaming charges incurred when using the Website outside your home region</li>
          </ul>
          <p>
            You are solely responsible for any charges incurred by your mobile
            network provider while using the Website.
          </p>
        </>
      ),
    },
    {
      id: "responsibility",
      title: "Responsibility of Use",
      body:
        "You are responsible for ensuring your device remains charged and functional while accessing the Website. GlobalGiftPass.io cannot be held liable for service disruptions caused by device-related issues, such as low battery or hardware failure.",
    },
    {
      id: "third-party",
      title: "Third-Party Information & Reliance",
      body:
        "Although we strive to provide accurate and up-to-date information, certain content on the Website may rely on third-party sources. GlobalGiftPass.io does not accept liability for any losses, direct or indirect, arising from reliance on such information.",
    },
    {
      id: "payments",
      title: "Payments",
      body:
        "We accept online payments using Visa and MasterCard credit/debit cards. For secure transactions, please ensure your payment details are accurate and up to date.",
    },
    {
      id: "fraud",
      title: "Fraud Prevention",
      body:
        "We reserve the right to hold, review, or cancel any suspicious or potentially fraudulent transactions. This may include additional checks or temporary holds as part of our effort to protect our customers and our platform.",
    },
    {
      id: "kyc",
      title: "KYC Clause",
      body:
        "Additional verification may be requested at our discretion to complete an order or process a refund. Failure to provide requested documents may result in order delay or cancellation.",
    },
    {
      id: "chargeback",
      title: "Chargeback Abuse",
      body:
        "Fraudulent chargeback disputes and abusive claims may be reported to card issuers, payment providers, and relevant authorities. We reserve the right to take any action necessary to protect our business and comply with payment provider policies.",
    },
    {
      id: "restricted",
      title: "Restricted Jurisdictions",
      body:
        "Access and use of the Website are not permitted from sanctioned or restricted countries. Orders originating from restricted jurisdictions may be canceled and no refund will be issued in violation of applicable law.",
    },
    {
      id: "delivery",
      title: "Delivery Clause",
      body:
        "Orders may be delayed for additional security screening or verification. We will notify you if any delay occurs, but we are not responsible for delays caused by fraud prevention or compliance checks.",
    },
    {
      id: "amendments",
      title: "Amendments to Terms",
      body:
        "We reserve the right to update or modify these Terms & Conditions at any time. You are encouraged to review this page periodically to stay informed of any changes. Updates will be posted on this page and take effect immediately upon publication.",
    },
    {
      id: "law",
      title: "Governing Law",
      body:
        "These Terms & Conditions are governed by and construed in accordance with the laws of the United Arab Emirates (UAE). Any disputes or claims arising from these terms will be resolved under UAE jurisdiction.",
    },
    {
      id: "contact",
      title: "Contact Information",
      body: (
        <>
          <p>For any questions or concerns regarding these Terms &amp; Conditions, contact us:</p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:support@globalgiftpass.io">support@globalgiftpass.io</a>
            </li>
            <li>VentureWorks Dynamics LLC, Sharjah Media City, Sharjah, UAE</li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <PolicyLayout
      slug="tos"
      eyebrow="TERMS OF SERVICE"
      title="Terms &"
      accent="conditions"
      sub="The agreement between you and GlobalGiftPass when you use our website and services."
      lastUpdated="January 2026"
      intro={
        <p>
          These Terms &amp; Conditions govern your use of GlobalGiftPass.io.
          Please read them carefully before using the Website — by accessing or
          using the platform, you accept these terms in full.
        </p>
      }
      notice="Customers under the age of 18 may not register or transact on this Website."
      sections={sections}
    />
  );
};

export default TermsandCondition;
